<span>
  <span ng-show="plantio.loading">
    <i class="fa fa-spinner fa-spin"></i>
  </span>
  <span ng-hide="plantio.loading">
    {{plantio.dataPlantio.inicio ? (plantio.dataPlantio.inicio | date:'dd/MM/yy') : 'n/a'}}
    <span ng-if="plantio.dataPlantio.inicio && plantio.dataPlantio.fim && plantio.dataPlantio.inicio != plantio.dataPlantio.fim">
      &nbsp;à {{plantio.dataPlantio.fim | date:'dd/MM/yy'}}
    </span>
  </span>
</span>